import React, { Component } from 'react';
import axios from 'axios';
import Job from './Job';
import { Droppable } from 'react-beautiful-dnd';

export default class MemberJobList extends Component {
    state = {
        isOpen: true,
        tipOffDeleted: false,
    };

    toggleAccordion = () => {
        this.setState((prev) => ({ isOpen: !prev.isOpen }));
    };

    handleTipOffClick = () => {
        const { member, showTipOffModal } = this.props;
        showTipOffModal(true, member);
    };

    handleDeleteTipOff = (tipOffId) => {
        const { member } = this.props;

        if (!window.confirm('Remove this tip-off from the operative?')) {
            return;
        }

        axios.delete(`/providers/${this.props.providerId}/tip-offs/delete`, {
                data: {
                    operative_id: member.id,
                    tip_off_id: tipOffId,
                },
            })
            .then(() => {
                this.setState({ tipOffDeleted: true });
            })
            .catch((error) => {
                console.error(error);
                alert('Failed to remove tip-off');
            });
    };

renderTipOffBanner(member, tipOffActive) {
    if (!tipOffActive || !member.tipOff) {
        return null;
    }

    return (
        <div className="alert alert-warning mb-2 text-center" style={{ fontWeight: 'bold' }}>
            ⚠ Operative must tip-off

            <div
                style={{
                    fontSize: '14px',
                    marginTop: '4px',
                }}
            >
                📍 {member.tipOff.name}
                {member.tipOff.address && ` — ${member.tipOff.address}`}
            </div>

            <div style={{ marginTop: '6px' }}>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={(e) => {
                        e.stopPropagation();
                        this.handleDeleteTipOff(member.tipOff.id);
                    }}
                >
                    ✕ Remove
                </button>
            </div>
        </div>
    );
}


    renderReviewBanner(member) {
        if (!member.needsReview || !member.reviewJob) {
            return null;
        }

        return (
            <div className="alert alert-info mb-2 text-center" style={{ fontWeight: 'bold' }}>
                ⛔ Tip-off completed — review required before assigning another
                <div style={{ marginTop: '6px' }}>
                    <a
                        href={member.reviewJob.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-outline-primary"
                    >
                        Review Job #{member.reviewJob.number}
                    </a>
                </div>
            </div>
        );
    }

    render() {
        const { isOpen, tipOffDeleted } = this.state;
        const {
            member,
            jobs,
            members,
            selectedJobs,
            assignMultipleJobs,
            quickAssign,
            onClick,
        } = this.props;

        const tipOffActive = member.needsTipOff && !tipOffDeleted;
        const tipOffBlocked = tipOffActive || member.needsReview;

        return (
            <div className="order-jobs-holder">
                <div className="accordion">
                    <div className="accordion-header" onClick={this.toggleAccordion}>
                        <h5>
                            {member.name}
                            <span style={{ float: 'right', fontSize: '30px', cursor: 'pointer' }}>
                                {isOpen ? '-' : '+'}
                            </span>
                        </h5>
                    </div>

                    {isOpen && (
                        <div className="accordion-body">
                            {selectedJobs?.length > 0 && (
                                <button
                                    className="btn btn-cw-primary mb-2"
                                    onClick={() => assignMultipleJobs(member.id)}
                                >
                                    Assign Jobs
                                </button>
                            )}

                            <button
                                className="btn btn-primary mb-2"
                                onClick={this.handleTipOffClick}
                                disabled={tipOffBlocked}
                            >
                                {tipOffActive
                                    ? 'Tip-Off Active'
                                    : member.needsReview
                                      ? 'Tip-Off Pending Review'
                                      : 'Assign Tip-Off'}
                            </button>

                            {this.renderTipOffBanner(member, tipOffActive)}
                            {this.renderReviewBanner(member)}

                            <Droppable droppableId={member.id.toString()}>
                                {(provided) => (
                                    <div
                                        className="table-container"
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                    >
                                        <div className="flex-table header transform-text">
                                            <div className="flex-row">Select</div>
                                            <div className="flex-row">Date Created</div>
                                            <div className="flex-row">Date Ready</div>
                                            <div className="flex-row">Special Requests</div>
                                            <div className="flex-row">Site Address</div>
                                            <div className="flex-row">Job Number</div>
                                            <div className="flex-row">Type of Job</div>
                                            <div className="flex-row">Customer Name</div>
                                            <div className="flex-row">Actions</div>
                                            <div className="flex-row">Assign</div>
                                        </div>

                                        {jobs?.length > 0 ? (
                                            jobs.map((job, index) => {
                                                const availableMembers = (members || []).filter(
                                                    (m) => m.value !== member.value
                                                );

                                                return (
                                                    <Job
                                                        key={job.id}
                                                        index={index}
                                                        job={job}
                                                        memberId={member.id}
                                                        onClick={onClick}
                                                        members={availableMembers}
                                                        quickAssign={quickAssign}
                                                        openTipOffModal={() =>
                                                            this.props.showTipOffModal(true, member)
                                                        }
                                                        updateSpecialRequests={this.props.updateSpecialRequests}
                                                        unassignJob={this.props.unassignJob}
                                                    />
                                                );
                                            })
                                        ) : (
                                            <p className="text-center mt-2">No jobs allocated</p>
                                        )}

                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
